(() => {
  if ( typeof local_stores === 'undefined' || typeof local_store_plugin_url === 'undefined' ) {
    return;
  }

  // get store Filter
  function getStoreFilter(props) {
    const filterText = props.filterText;
    const filterCity = props.filterCity;
    const filterDistrict = props.filterDistrict;
    const stores = props.stores;
    let store_filter = [];

    stores.forEach(store => {
      if ( filterText && ( ! store.address.toLowerCase().includes(filterText.toLowerCase()) && ! store.name.toLowerCase().includes(filterText.toLowerCase()) ) ) {
        return;
      }

      if ( filterCity && store.city !== filterCity ) {
        return;
      }

      if ( filterDistrict && store.district !== filterDistrict ) {
        return;
      }

      store_filter.push(store);
    });

    return store_filter;
  }

  // get City from store
  function getCity(stores) {
    if ( ! stores ) return [];

    let cities = new Set();

    cities.add('Toàn Quốc');

    stores.forEach((store) => {
      if ( typeof store.city === 'undefined'  ) return;

      cities.add( store.city );
    });

    return [...cities];
  }

  // get district from store
  function getDistricts(props) {
    let districts = new Set();

    districts.add('Quận/Huyện');

    if ( ! props.filterCity || ! props.stores ) return districts;

    props.stores.forEach(store => {
      if ( store.city !== props.filterCity) return;

      districts.add( store.district );
    });

    return [...districts]
  }

  // Info name component
  function InfoName(props) {
    return (<div className="local-store__info-name">
      <strong>{props.name}</strong>
    </div>);
  }

  // Store address component
  function StoreAddress(props) {
    return (<ul className="local-store__address">
      <li>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="640" height="640" viewBox="0 0 640 640">
          <title/>
          <g id="icomoon-ignore">
          </g>
          <path fill="#FDCC0C" d="M619.744 579.264l-43.744-131.264h-48l26.656 128h-469.312l26.656-128h-48l-43.776 131.264c-11.104 33.408 8.576 60.736 43.776 60.736h512c35.2 0 54.88-27.328 43.744-60.736zM480 160c0-88.352-71.616-160-160-160s-160 71.648-160 160c0 152.8 160 320 160 320s160-167.2 160-320zM233.6 161.92c0-47.712 38.656-86.368 86.4-86.368s86.4 38.656 86.4 86.368c0 47.744-38.688 86.4-86.4 86.4s-86.4-38.688-86.4-86.4z"/>
        </svg>
        {props.address}
      </li>
      <li>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512" viewBox="0 0 512 512">
          <title/>
          <g id="icomoon-ignore">
          </g>
          <path fill="#FDCC0C" d="M352 320c-32 32-32 64-64 64s-64-32-96-64-64-64-64-96 32-32 64-64-64-128-96-128-96 96-96 96c0 64 65.75 193.75 128 256s192 128 256 128c0 0 96-64 96-96s-96-128-128-96z"/>
        </svg>

        {props.phones}
      </li>
    </ul>);
  }

  // Store action component
  function StoreAction(props) {
    return (<div className="local-store__action">
      <a href={props.direction}>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="352" height="448" viewBox="0 0 352 448">
          <title/>
          <g id="icomoon-ignore">
          </g>
          <path fill="#0078A8" d="M350.25 87.25l-160 320c-2.75 5.5-8.25 8.75-14.25 8.75-1.25 0-2.5-0.25-3.75-0.5-7.25-1.75-12.25-8-12.25-15.5v-144h-144c-7.5 0-13.75-5-15.5-12.25s1.75-14.75 8.25-18l320-160c2.25-1.25 4.75-1.75 7.25-1.75 4.25 0 8.25 1.5 11.25 4.75 5 4.75 6.25 12.25 3 18.5z"/>
        </svg>
        Chỉ đường
      </a>
    </div>);
  }

  // Box Image component
  function BoxImage(props) {
    return (<div className="local-store__image">
      <img src={props.url} alt={props.alt} loading="lazy" />
    </div>);
  }

  // Box info component
  function BoxInfo(props) {
    return (<div className="local-store__box-info">
      <InfoName name={props.store.name} />
      <StoreAddress address={props.store.address} phones={props.store.phone} />
      <StoreAction direction={props.store.google_maps_direction} />
    </div>);
  }

  // box item component
  function BoxItem(props) {
    return (<div className="local-store__box-item" data-latlng={props.store.latlng}>
      <BoxImage url={props.store.image.url} alt={props.store.image.alt} />
      <BoxInfo {...props} />
    </div>);
  }

  // Search Box component
  function SearchBox(props) {
    let cities = getCity(props.stores);
    let Districts = getDistricts(props);
    let optionCities = [];
    let optionDistricts = [];

    cities.forEach((city) => {
      optionCities.push(
        <option key={city} value={city === 'Toàn Quốc' ? '' : city}>{city}</option>
      );
    });

    Districts.forEach((district) => {
      optionDistricts.push(
        <option key={district} value={district === 'Quận/Huyện' ? '' : district}>{district}</option>
      );
    });

    function handleTextChange(event) {
      props.onFilterTextChange(event.target.value);
    }

    function handleCityChange(event) {
      props.onFilterCityChange(event.target.value);
    }

    function handleDistrictChange(event) {
      props.onFilterDistrictChange(event.target.value);
    }

    function handleSubmit(event) {
      event.preventDefault();
    }

    return (<div className="local-store__search-box">
      <form action="" onSubmit={handleSubmit}>
        <div className="local-store__form-item form-item-search">
          <input type="text" name="search" placeholder="Nhập từ khoá" value={props.filterText} onChange={handleTextChange} />

          <button type="submit">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512" viewBox="0 0 512 512">
              <title/>
              <g id="icomoon-ignore">
              </g>
              <path d="M496.131 435.698l-121.276-103.147c-12.537-11.283-25.945-16.463-36.776-15.963 28.628-33.534 45.921-77.039 45.921-124.588 0-106.039-85.961-192-192-192s-192 85.961-192 192 85.961 192 192 192c47.549 0 91.054-17.293 124.588-45.922-0.5 10.831 4.68 24.239 15.963 36.776l103.147 121.276c17.661 19.623 46.511 21.277 64.11 3.678s15.946-46.449-3.677-64.11zM192 320c-70.692 0-128-57.308-128-128s57.308-128 128-128 128 57.308 128 128-57.307 128-128 128z"/>
            </svg>
          </button>
        </div>

        <div className="local-store__form-item form-item-city">
          <select name="city" value={props.filterCity} onChange={handleCityChange} >
            {optionCities}
          </select>
        </div>

        <div className="local-store__form-item form-item-district">
          <select name="district" value={props.filterDistrict} onChange={handleDistrictChange} >
            {optionDistricts}
          </select>
        </div>
      </form>
    </div>);
  }

  // Search results component
  function SearchResults(props) {
    const store_filter = getStoreFilter({...props});

    const list = store_filter.map((store) => {
      return <BoxItem key={store.latlng} data-latlng={store.latlng} store={store} />;
    });

    React.useEffect(() => {
      if ( window.innerWidth < 992 ) return;

      let height = document.querySelector('.local-store').clientHeight - document.querySelector('.local-store__search-box').clientHeight;

      document.querySelector('.local-store__search-result').style.height = height + 'px';
    }, []);

    return (<div className="local-store__search-result">
      {list}
    </div>)
  }

  // Search wrap component
  function SearchWrap(props) {
    return (<div className="local-store__search-wrap">
      <SearchBox {...props} />
      <SearchResults {...props} />
    </div>);
  }

  // Maps component
  function Maps(props) {
    const store_filter = getStoreFilter({...props});

    React.useEffect(() => {
      if( typeof window.map === 'undefined' ) {
        let zoom = window.innerWidth >= 992 ? 6 : 5;

        window.map = L.map('local-map', { gestureHandling: true }).setView([16.2, 106], zoom );

        let tiles = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
          maxZoom: 18,
          attribution: null,
          id: 'mapbox/streets-v11',
          tileSize: 512,
          zoomOffset: -1
        }).addTo(map);

        // add maker
        let icon = L.icon({
            iconUrl: local_store_plugin_url.url + 'assets/frontend/pin-1.png',
            iconSize: [44, 60],
            iconAnchor: [22, 60],
            popupAnchor: [0, -60]
        });

        store_filter.forEach((store) => {
          let latLng = store.latlng.split(',');

          let marker = L.marker([latLng[0], latLng[1]], {icon}).addTo(map);

          let popupContent = document.querySelector(`.local-store__box-item[data-latlng="${store.latlng}"]`);

          let layer = marker.bindPopup(popupContent.outerHTML, { maxWidth: window.innerWidth >= 500 ? 460 : 240 });

          document.addEventListener('click',  (event) => {
            let popupContent = document.querySelector(`.local-store__box-item[data-latlng="${store.latlng}"]`);

            event.path.forEach((path) => {
              if ( path === popupContent ) {
                layer.togglePopup();
              }
            });
          });
        });
      } else if ( store_filter.length === 1 ) {
        let latLng = store_filter[0].latlng.split(',');

        map.setView([latLng[0], latLng[1]], 16 );
      } else if ( store_filter.length > 1 && props.filterCity ) {
        let latLngBounds = [];

        store_filter.forEach((store) => {
          let latLng = store.latlng.split(',');

          latLngBounds.push( latLng );
        });

        map.fitBounds( latLngBounds, { paddingTopLeft: [100, 100], paddingBottomRight: [100, 100] } );
      } else {
        map.setView([16.2, 106], 6 );
      }
    });

    return <div id="local-map"></div>
  }

  // Local Store component
  function LocalStore(props) {
    const [filterText, setFilterText] = React.useState();
    const [filterCity, setFilterCity] = React.useState();
    const [filterDistrict, setFilterDistrict] = React.useState();

    function handleFilterTextChange(value) {
      setFilterText(value);
    }

    function handleFilterCityChange(value) {
      setFilterCity(value);
      setFilterDistrict('');
    }

    function handleFilterDistrictChange(value) {
      setFilterDistrict(value);
    }

    return (<div className="local-store">
      <SearchWrap
        onFilterTextChange={handleFilterTextChange}
        filterText={filterText}
        onFilterCityChange={handleFilterCityChange}
        filterCity={filterCity}
        onFilterDistrictChange={handleFilterDistrictChange}
        filterDistrict={filterDistrict}
        stores={props.stores} />
      <Maps filterText={filterText} filterCity={filterCity} filterDistrict={filterDistrict} stores={props.stores} />
    </div>);
  }

  function App() {
    return <LocalStore stores={local_stores} />
  }

  const container = document.querySelector('#find-store');
  const root = ReactDOM.createRoot(container);
  root.render(<App />);
})();